import IconContainer from '@/components/IconContainer'

export default function IconMedium(props) {
  return (
    <IconContainer
      {...props}
      width="20"
      height="20"
      ariaLabel="Medium Icon"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path d="M11.2812 9.99994C11.2812 13.1814 8.75575 15.7604 5.64067 15.7604C2.5256 15.7604 0 13.1814 0 9.99994C0 6.8185 2.52541 4.23926 5.64067 4.23926C8.75594 4.23926 11.2812 6.8185 11.2812 9.99994ZM17.4717 9.99973C17.4717 12.9944 16.209 15.423 14.6514 15.423C13.0938 15.423 11.8311 12.9944 11.8311 9.99973C11.8311 7.0051 13.0936 4.5765 14.6512 4.5765C16.2088 4.5765 17.4715 7.00432 17.4715 9.99973H17.4717ZM19.0081 14.8584C19.556 14.8584 20 12.6825 20 10C20 7.31679 19.5558 5.14166 19.0081 5.14166C18.4604 5.14166 18.0164 7.31698 18.0164 10C18.0164 12.6831 18.4602 14.8584 19.0081 14.8584Z" />
    </IconContainer>
  )
}
